// Hand-crafted "Support Christovibes" card shown when Africa exclusion is on
// AND the visitor is in Africa, so the space isn't just blank. Admin-editable.
import React from 'react';
import { HeartHandshake, ArrowUpRight } from 'lucide-react';

export default function SponsorCard({ card, className = '', compact = false }) {
  if (!card?.enabled) return null;
  const { title, message, cta_label, cta_url } = card;

  const inner = (
    <div className={`bg-gradient-to-br from-[#D4AF37]/12 to-[#171A21] border border-[#D4AF37]/25 rounded-2xl ${compact ? 'p-4 sm:p-5' : 'p-6 sm:p-8'}`}>
      <div className="flex items-start gap-4">
        <div className={`${compact ? 'w-10 h-10' : 'w-12 h-12'} rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center shrink-0`}>
          <HeartHandshake size={compact ? 18 : 22} className="text-[#D4AF37]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className={`text-white font-semibold ${compact ? 'text-base' : 'text-lg sm:text-xl'}`} style={{ fontFamily: 'Clash Display, sans-serif' }}>
            {title || 'Support Christovibes'}
          </h3>
          {message && (
            <p className={`text-[#94A3B8] mt-1 ${compact ? 'text-xs sm:text-sm' : 'text-sm'} leading-relaxed`}>
              {message}
            </p>
          )}
          {cta_url && cta_label && (
            <a
              data-testid="sponsor-card-cta"
              href={cta_url}
              target={cta_url.startsWith('/') ? '_self' : '_blank'}
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-1.5 bg-[#D4AF37] text-[#0F1115] font-semibold hover:bg-[#E8C24D] rounded-full px-4 py-2 text-xs sm:text-sm transition-colors"
            >
              {cta_label} <ArrowUpRight size={14} />
            </a>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div data-testid="sponsor-card" className={`w-full ${compact ? 'my-3' : 'my-8'} ${className}`}>
      {inner}
    </div>
  );
}
